// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2dbc37fe","239":"ff75e0b7","732":"8d5549ae"}[chunkId] + ".chunk.js";
};